// @ts-check
import asCatalogSections from '../../components/asCatalogSections.js';
import WeinBurgenlandAward from './WeinBurgenlandAward';

export const AwardSheet = asCatalogSections(WeinBurgenlandAward);
